import React from 'react';
import { Provider } from 'react-redux';
import RentalPage from '../../page/RentalPage';
import store from '../../configureStore';
import * as frameActions from '../../actions/frames';
import * as settingActions from '../../actions/settings';
import ComponentWidgetContainer from '../ComponentWidgetContainer';

export default class RentalWidgetContainer extends ComponentWidgetContainer {
  constructor(props) {
    super(props);

    store.dispatch(frameActions.setIsRentalFlag(true));
  }

  render() {
    return (
      <div>
        <Provider store={store}>
          <RentalPage />
        </Provider>
      </div>
    );
  }
}

window.changeStyle = (value) => store.dispatch(settingActions.setStyle(value));
window.changeTranslation = (key, value) => { store.dispatch(settingActions.setTranslation({ key, value })); };
window.changeSetting = (key, value) => store.dispatch(settingActions.setSetting({ key, value }));
